import { useMemo } from "react";
import ReactImageMagnify from 'react-image-magnify';
import { FlagRegionByIso } from "components/Function";
import { Link } from "react-router-dom";

const useColumnTableInfluencersByShop = (heightRow = 100) => {
    const columns = useMemo(() => {
        return [
            {
                field: "_id",
                headerName: "",
                sortable: false,
                editable: false,
                cellClass: "centered-cell",
                width: 10,
                cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
            },
            {
                field: "unique_id",
                headerName: "Creator",
                sortable: false,
                editable: false,
                autoHeight: true,
                cellClass: "overflow-visible",
                width: 500,
                cellRenderer: ({ data: row, cell }) => (
                    <div className="d-flex align-items-center p-4" style={{ height: heightRow - 1 + "px" }}>
                        <div className="me-3">
                            {/* <Link to={row.avatar_url} target="_blank"> */}
                            <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: row.avatar_url }, largeImage: { src: row.avatar_url, width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 }, imageClassName: "symbol symbol-45px symbol-circle" }} />
                            {/* </Link> */}
                        </div>
                        <div
                            className="d-flex flex-column lh-lg gap-2 w-100px"
                            style={{
                                overflow: "hidden",
                                flex: "1",
                            }}
                        >
                            <span
                                className="mb-0 fw-bold"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: "1",
                                }}
                            >
                                <Link
                                    role="button"
                                    target="_blank"
                                    to={`/admin/spy-advanced/influencers/${row.influencer_id}`}
                                >
                                    {row.influencer_name}
                                </Link>
                            </span>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {row.region?.key ? (
                                    <FlagRegionByIso name={row.region.name} iso={row.region.key} />
                                ) : (
                                    ""
                                )}
                                {Boolean(row.is_email) && (
                                    <i
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={"Email"}
                                        className="fa fa-envelope-o fs-3"
                                    ></i>
                                )}
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                field: "follower_count",
                headerName: "Followers",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "heart_count",
                headerName: "Likes",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "category_product",
                headerName: "Product Category",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "sales",
                headerName: "Sales",
                headerClass: "text-info",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "gmv",
                headerName: "GMV",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "video_count",
                headerName: "Related Videos",
                cellClass: "centered-cell",
                sortable: false,
                cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                    <button className="btn btn-outline btn-outline-info me-2 mb-2 al-border-radius-8">
                        <i className="fa fa-youtube-play fs-3"></i> Video {row.video_count}
                    </button>
                ),
            },
            {
                field: "live_count",
                headerName: "Related Lives",
                cellClass: "centered-cell",
                sortable: false,
                cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                    <button className="btn btn-outline btn-outline-info me-2 mb-2 al-border-radius-8">
                        <i className="fa fa-video-camera fs-3"></i> Live {row.live_count}
                    </button>
                ),
            },
            {
                field: "-",
                headerName: "Actions",
                editable: false,
                cellClass: "centered-cell",
                width: 140,
                // pinned: "right",
                cellRenderer: ({ data: row }) => (
                    <>
                        <Link
                            role="button"
                            to={`/admin/spy-advanced/influencers/${row.influencer_id}`}
                            className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                            data-tooltip-id="my-tooltip"
                            target="_blank"
                        >
                            <i className="fa fa-search fs-2"></i>
                        </Link>
                    </>
                ),
            },
        ];
    }, [heightRow]);

    return columns;
};

export default useColumnTableInfluencersByShop;
